import React, { PureComponent } from "react";
import Flickity from "flickity";
import Event from "./Event";
import { eventListShape } from "./shapes";
import flickityOptions from "../../../helpers/flickityOptions";

export default class TimelineSlider extends PureComponent {
  static displayName = "Timeline.Slider";

  static propTypes = eventListShape;

  componentDidMount() {
    if (!this.slider) return null;

    this.timeline = new Flickity(this.slider, {
      ...flickityOptions,
      adaptiveHeight: true,
      initialIndex: this.props.active,
    });

    this.timeline.on("change", this.updateActive);
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      this.timeline.select(this.props.active);
    }
  }

  get id() {
    return this.props.id;
  }

  get events() {
    return this.props.events;
  }

  get eventCount() {
    return this.events.length;
  }

  getNextEventDate(index) {
    if (index === this.eventCount - 1) return null;
    const { dateObj } = this.events[index + 1];
    return dateObj.getFullYear();
  }

  updateActive = (active) => {
    if (this.props.active !== active) {
      this.props.onUpdate(active);
    }
  };

  render() {
    const { active, onUpdate } = this.props;

    if (this.events.length <= 1) {
      const event = this.events[0];

      return <Event id={`${this.id}-0`} {...event} onClick={() => {}} />;
    }

    return (
      <div className="m-slideshow">
        <div
          className="m-slideshow__inner"
          ref={(c) => {
            this.slider = c;
          }}
        >
          {this.events.map((event, i) => (
            <Event
              key={i}
              id={`${this.id}-${i}`}
              {...event}
              onClick={() => this.props.onUpdate(active + 1)}
              nextDate={this.getNextEventDate(i)}
            />
          ))}
        </div>
      </div>
    );
  }
}
